define(function(require,exports,module){
	var merge;
	return merge=function (to,from,more){
		var key;
		for(key in from){
			if(from.hasOwnProperty(key)){
				to[key]=from[key];
			}
		}
		if(more){
			merge(to,more,arguments[3]);
		}
		return to;
	}
});